export default __webpack_public_path__ + "static/media/2318.52ad0df3.png";